function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M483.4,113.8c-5.5,0-11.1,1.6-16.2,5.1l-97.5,60.7v-51.8c0-23.4-20.6-42.4-46.1-42.4H46.1c-25.5-0.1-46.1,18.9-46.1,42.3 v256.3c0,23.4,20.6,42.4,46.1,42.4h277.7c25.4,0,46.1-19,46.1-42.4v-51.8l97.5,60.7c5.1,3.5,10.8,5.1,16.2,5.1 c14.8,0,28.6-11.6,28.6-28V141.8C511.9,125.4,498.2,113.8,483.4,113.8z M327.1,206.2v176.8c-0.6,0.3-1.6,1-3.4,1H46.1 c-1.8,0-2.8-0.6-3.4-1V129.1c0.6-0.3,1.6-1,3.4-1h277.7c1.8,0,2.8,0.6,3.4,1L327.1,206.2L327.1,206.2z M469.3,344.2l-99.5-62V230 l99.5-62V344.2z"
});

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.eaa95ced.svg";
export { ForwardRef as ReactComponent };